var render = function render(){var _vm=this,_c=_vm._self._c;return _c('insight',{attrs:{"insight":_vm.insight,"animation-name":"hever-benefit.json","button-text":"לפרטים נוספים","button-action":_vm.buttonAction},scopedSlots:_vm._u([{key:"insight-text",fn:function(){return [_c('div',[_vm._v("במועדון חֶבֶר? מגיעה לך הטבה על מנוי רייזאפ: 50% הנחה ל־6 חודשים!")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }